import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import glamorous from "glamorous";
import { Card } from "react-toolbox/lib/card";
import { formatPhoneNumber } from "../../../../../common/components/Form";
import {
  fillWithDefaults,
  fillableDefaults
} from "../../../utils/defaultDataHelper";
import OrganizationActions from "../../../actions/organizations";
import CustomerActions from "../../../actions/customers";
import AddressForm from "../../AddressForm";
import OnboardingNavigation from "../OnboardingNavigation";
import { StepHeader } from "./index";
import Dropdown from 'react-toolbox/lib/dropdown';
import Form from '../../../../../common/components/Form';
import ThemedInput from '../../../../../common/components/ThemedInput';


const AddressFormCard = glamorous(Card)({
  padding: "1.4rem 1.6rem",
  overflow: "visible",
  boxShadow: "none !important"
});

class BusinessAddress extends React.Component {
  static propTypes = {
    currentOrganization: PropTypes.shape({
      addresses: PropTypes.array,
      organizationDetails: PropTypes.object
    }),
    currentCustomer: PropTypes.shape({
      personalDetails: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        prefix: PropTypes.string,
      })
    }),
    actions: PropTypes.shape({
      organization: PropTypes.object,
      customer: PropTypes.object,
    })
  };
  state = {
    forceReload: true,
    addressData: {
      org:[
        {
          type:"Org"
        }
      ],
      personals:[
        {
          type: "Personal"
          }
      ],
      addresses: [
        {
          type: "Business",
          ...fillableDefaults.address
        },
        {
          type: "Mailing",
          ...fillableDefaults.address
        }
      ],
      phoneNumbers: [
        {
          type: "Business",
          ...fillableDefaults.phone
        }
      ]
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      // ...this.state,
      addressData: this.loadAddressFromProps(this.state, props),
      submitSuccess: false
    };
  }



  componentWillReceiveProps(nextProps) {
    this.setState(prevState => {
      const addressData = this.loadAddressFromProps(prevState, nextProps);
      return {
        ...prevState,
        addressData
      };
    });
  }

  loadAddressFromProps = (state, props) => {
    const { currentOrganization: org, currentCustomer } = props;
    let newAddress = state.addressData;

    if (org) {
      
      const addressTypes = ["Business", "Mailing"];
      const addresses = fillWithDefaults({
        containingObject: org,
        fillType: "address",
        propName: "addresses",
        typeList: addressTypes
      }).addresses.filter(address => addressTypes.indexOf(address.type) >= 0);

      const phoneNumbers = fillWithDefaults({
        containingObject: org,
        fillType: "phone",
        propName: "phoneNumbers",
        typeList: ["Business"]
      })
        .phoneNumbers.filter(phone => phone.type === "Business")
        .map(phone => ({
          ...phone,
          number: formatPhoneNumber("$1-$2-$3", phone.number || "")
        }));

      newAddress = {
        addresses,
        phoneNumbers
      };

      if(props.currentStep.key == "business-address"){
        const orgDetail = [
                {
                  key:"name",type:"Business Name",name:currentCustomer.summaryDetails.organizationUnboundName
                }
              ]
          const customers = [
            {key:"prefix",type:"Prefix",prefix:currentCustomer.personalDetails.prefix},
            {key:"firstName",type:"First Name", firstName:currentCustomer.personalDetails.firstName},
            {key:"lastName",type:"Last Name",lastName:currentCustomer.personalDetails.lastName},
            ];

            newAddress.orgDetail = orgDetail;
            newAddress.customers = customers;
      }
    }

    return newAddress;
  };

  handleSave = ({ addresses, phoneNumbers , customers, orgDetail},  isDirty) => {
    this.setState(prevState => ({
      ...prevState,
      forceReload: false
    }));

    // if no changes, assume success and navigate
    if (!isDirty) {
      return this.props.goForward();
    }

    const { currentOrganization, currentCustomer } = this.props;
    const { key } = currentOrganization || {};
    const requestBody = {
      key,
      addresses,
      phoneNumbers
    };

    if(this.props.currentStep.key == "business-address"){
        const { personalKey = key , personalDetails } = currentCustomer || {};

        const personalRequestBody = {
          key : currentCustomer.key,
          personalDetails: customers
        }

        this.props.actions.customer.put(personalRequestBody).then(results=>{
          //console.log(results);
        }); 

        requestBody.organizationDetails = orgDetail;
    }
    return this.props.actions.organization.put(requestBody).then(results => {
      if (
        results &&
        results.payload &&
        results.payload.resp &&
        results.payload.resp.ok
      ) {
        this.props.goForward();
      }
      return results;
    });
  };

  render() {

    return (
      <div>
        <StepHeader>
          Is your business info correct? If not, please update below.
        </StepHeader>
        <AddressForm
          includePersonal
          includeHeaders
          forceReload={this.state.forceReload}
          addressData={this.state.addressData}
          required={{
            Business: ["stateCode", "postalCode"],
            Mailing: ["addressLine1", "city", "stateCode", "postalCode"]
          }}
          FormWrapper={AddressFormCard}
          renderSubmit={() => (
            <OnboardingNavigation
              {...this.props}
              goForward={null}
              submitOnNext
            />
          )}
          handleSave={this.handleSave}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      organization: bindActionCreators(OrganizationActions, dispatch),
      customer: bindActionCreators(CustomerActions, dispatch)
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(BusinessAddress);



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/Steps/BusinessAddress.js